import { makeStyles } from '@branchjs/neo-components';

export const useStyles = makeStyles((theme) => ({
  input: {
    width: '100%',
  },
  label: {
    margin: '0',
    padding: '0',
  },
  error: {
    marginLeft: '5px',
  },
  form: {
    maxWidth: '478px',
    [theme.breakpoints.down('md')]: {
      margin: '0px',
    },
    paddingBottom: '24px',
    margin: '48px 0px 0px auto',
  },
  terms: {
    marginTop: theme.spacing(1),
  },
  showHidePasswordLink: {
    marginLeft: theme.spacing(0.5),
  },
}));
